import { api } from '@/core/api/';
import utils from '@/utils/utilities';

const URL = 'api/interventionplan';

export const getPlanInfo = (contractId, planId) =>
  api.get(`${URL}/${contractId}`, {
    params: {
      planId,
    },
  });

export const savePlan = (params) => api.post(`${URL}`, params);

export const getMeasureBankByUser = (disciplineTypeId) =>
  api.get(`${URL}/measurebankbyuser/${disciplineTypeId}`);

export const saveMeasureBankByUser = (params) =>
  api.post(`${URL}/measurebankbyuser`, params);

export const deleteMeasureBankByUser = (id) =>
  api.delete(`${URL}/measurebankbyuser/${id}`);

export const getMeasureCodes = () => api.get(`${URL}/measurecodes`);

export const downloadDocumentByAttachmentId = (attachmentId) =>
  api.get(`/api/documents/${attachmentId}`).then((response) => {
    utils.convertToBlob(response.data);
  });

export const downloadReport = (name) =>
  api.get(`${URL}/${name}`).then((response) => {
    utils.convertToBlob(response.data);
  });

export const saveinterventionplandocument = (params) =>
  api.post(`${URL}/saveinterventionplandocument`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getInterventionPlanHistory = (planId) =>
  api.get(`${URL}/${planId}/history`);

export const createElectronicDocument = (params) =>
  api.post(`${URL}/electronic`, params);

export const getSignatureParticipants = (params) =>
  api.get(`${URL}/participants`, {
    params: params,
  });

export const saveSignatureConfiguration = (params) =>
  api.post(`${URL}/signature/configuration`, params);

export const validateInterventionPlanDocumentWithAI = (
  params,
  documentTypeId
) =>
  api.post(
    `${URL}/validateinterventionplandocument/${documentTypeId}`,
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

export const changeElectronicDocumentStatus = (params) =>
  api.put(`${URL}/electronic/changedocumentstatus`, params);

export const getCodeExecutionLevelArchieved = () =>
  api.get(`${URL}/executionlevelarchieved/`);

export const getCurrentPeriod = () => api.get(`${URL}/currentperiod`);

export const saveInterventionPlanSummary = (planId, params) =>
  api.post(`${URL}/savesummary`, params);

export const deleteArchivement = (archivementId) =>
  api.put(`${URL}/deleteArchivement/${archivementId}`);
